import React from 'react'
import { Button, Box as Column, Icon, Input, Box as OuterWrapper } from '@node-space/ui-components'

const SearchFields = ({
  searchByTransactionHash,
  t,
  queryPaymentsLinkBy,
  searchByRef,
  searchByUUID,
  onSearchByRefChanged,
  onSearchByTransactionHash,
  onSearchByUUID,
}) => {
  return (
    <Column className="flex w-full mr-3 gap-3">
      <OuterWrapper testId="filter-search-field-wrapper" flexSize="auto">
        <Input
          disabled={!!searchByTransactionHash || !!searchByUUID}
          placeholderText={t('payments.searchByReference')}
          testId="filter-search-field"
          onChange={e => onSearchByRefChanged(e?.target.value)}
          searchable
          value={searchByRef}
          iconPosition="right"
          IconButton={
            searchByRef && (
              <Button
                variant="ghost"
                onClick={() => onSearchByRefChanged('')}
                iconElement={<Icon name="X" />}
              />
            )
          }
        />
      </OuterWrapper>
      <OuterWrapper testId="filter-search-field-wrapper" flexSize="auto">
        <Input
          disabled={!!queryPaymentsLinkBy || !!searchByRef || !!searchByUUID}
          placeholderText={t('payments.searchByHash')}
          testId="filter-search-field-by-transaction-hash"
          onChange={e => onSearchByTransactionHash(e?.target.value)}
          searchable
          value={searchByTransactionHash}
          iconPosition="right"
          IconButton={
            searchByTransactionHash && (
              <Button
                variant="ghost"
                onClick={() => onSearchByTransactionHash('')}
                iconElement={<Icon name="X" />}
              />
            )
          }
        />
      </OuterWrapper>
      <OuterWrapper testId="filter-search-field-wrapper" flexSize="auto">
        <Input
          disabled={!!queryPaymentsLinkBy || !!searchByRef || !!searchByTransactionHash}
          placeholderText={t('payments.searchByUUID')}
          testId="filter-search-field-by-uuid"
          onChange={e => onSearchByUUID(e?.target.value)}
          searchable
          value={searchByUUID}
          iconPosition="right"
          IconButton={
            searchByUUID && (
              <Button
                variant="ghost"
                onClick={() => onSearchByUUID('')}
                iconElement={<Icon name="X" />}
              />
            )
          }
        />
      </OuterWrapper>
    </Column>
  )
}

export default SearchFields
